function onTabClick(event) {
  var activeTabs = document.querySelectorAll(".tab-active"); // deactivate existing active tab and panel
  // for( let i = 0; i < activeTabs.length; i++) {
  //   activeTabs[i].className = activeTabs[i].className.replace('active', '');
  // }

  activeTabs.forEach(function (tab) {
    tab.className = tab.className.replace("tab-active", "");
  }); // console.log('tab-click');
  // activate new tab and panel

  event.target.parentElement.className += " tab-active";
  document.getElementById(event.target.href.split("#")[1]).className += " tab-active";

  if (location.hash) {
    setTimeout(function () {
      window.scrollTo();
    }, 1);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var element = document.getElementById("nav-tab");

  if (element) {
    // Activate first tab nav link
    var firstChildNav = document.getElementById("nav-tab").firstElementChild;
    firstChildNav.classList.add("tab-active"); // Activate first content tab pane

    var firstChildPane = document.getElementById("tab-pane").firstElementChild;
    firstChildPane.classList.add("tab-active");
    element.addEventListener("click", onTabClick, false);
  }
}); // Create a media query list object